import { render, staticRenderFns } from "./IndividualPensionPlan.vue?vue&type=template&id=fa0c281a"
import script from "./IndividualPensionPlan.vue?vue&type=script&lang=js"
export * from "./IndividualPensionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports